import React, { useState } from "react";
import PropTypes from "prop-types";
import { App, Button, Form, Input, Modal, Radio } from "antd";
import { apiUpdateLoginDetails } from "api/apiTws";
import GenericCard from "components/UI/GenericCard/GenericCard";

const UpdateIBKRDetails = (props) => {
  const { completed, fetchIbAccountDetails } = props;
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);

  const handleUpdateDetails = async (values) => {
    try {
      await apiUpdateLoginDetails(values);
      message.success("IBKR Login Details Updated!");
      fetchIbAccountDetails();
      setIsOpen(false);
    } catch (err) {
      message.error("Failed to update IBKR Login Details!");
    }
  };

  return (
    <>
      <GenericCard
        title={
          completed ? (
            <span className="green">Update IBKR Login Details</span>
          ) : (
            <span>Set IBKR Login Details</span>
          )
        }
      >
        <div className="pb-8">
          {completed ? (
            <p className="green">You are all set up!</p>
          ) : (
            <p>
              You need to set your IBKR login details to start using the
              automation.
            </p>
          )}
        </div>
        <Button type="primary" onClick={() => setIsOpen(true)}>
          {completed ? "Update IBKR Login Details" : "Set IBKR Login Details"}
        </Button>
      </GenericCard>
      <Modal
        title={
          completed ? "Update IBKR Login Details" : "Set IBKR Login Details"
        }
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        width={500}
        destroyOnClose={true}
      >
        <Form
          form={form}
          layout="vertical"
          name="tws_login"
          onFinish={handleUpdateDetails}
          initialValues={{}}
          preserve={false}
        >
          <Form.Item
            name="username"
            label="Username"
            rules={[
              {
                required: true,
                message: "This field is required!",
              },
            ]}
          >
            <Input placeholder="Username" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[
              {
                required: true,
                message: "This field is required!",
              },
            ]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>

          <Form.Item
            name="tradingMode"
            label="Account Type"
            rules={[
              {
                required: true,
                message: "This field is required!",
              },
            ]}
          >
            <Radio.Group buttonStyle="solid">
              <Radio.Button value="live">Live</Radio.Button>
              <Radio.Button value="paper">Paper</Radio.Button>
            </Radio.Group>
          </Form.Item>

          <Form.Item shouldUpdate className="pt-2">
            {() => (
              <Button
                type="primary"
                htmlType="submit"
                disabled={
                  !form.isFieldsTouched(true) ||
                  !!form.getFieldsError().filter(({ errors }) => errors.length)
                    .length
                }
              >
                Update
              </Button>
            )}
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

UpdateIBKRDetails.propTypes = {
  completed: PropTypes.bool,
  fetchIbAccountDetails: PropTypes.func,
};

export default UpdateIBKRDetails;
